/**
 * Move focus to a screen when it appears.
 *
 * The Catch flow swaps whole screens in place rather than navigating, so the
 * element that had focus is simply removed. Without this, a keyboard or switch
 * user is dropped onto `document.body` after every tap, and a screen-reader
 * user hears nothing at all about the screen that just replaced the one they
 * were on — the tap appears to have done nothing.
 *
 * Applied to the incoming heading (or the plan block, where there is no
 * heading), which is also what a screen reader should read first.
 */
export function focusOnMount(node: HTMLElement): void {
  // `preventScroll` because these screens do not scroll; without it some
  // browsers nudge the layout when focus lands on a full-width block.
  node.focus({ preventScroll: true });
}
